import React, { Component } from "react";
import {getHours, getAMorPM, getWeekDayFromDateString, formatDateString} from '../../shared/dateFormatter';
import Popover from "@material-ui/core/Popover/Popover";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Fade from "@material-ui/core/Fade/Fade";
import TrackingDetailsPieceInfo from "../TrackingDetailsPieceInfo/TrackingDetailsPieceInfo";

class TrackingDetailsFlightInfo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPopper: null,
            isOverlayShown: false,
            isMobileNavOpen: false,
        };

        this.piecePopperNavigationAnchorElement = React.createRef()
    }

    getCSSForFlightStatusIcon = (input) => {
        if (input === undefined || input === null) {
            return 'tracking-details-flight-info-status-icon tracking-details-flight-info-status-icon__grey';
        }
        if (input.length > 0) {
            return 'tracking-details-flight-info-status-icon tracking-details-flight-info-status-icon__success';
        } else {
            return 'tracking-details-flight-info-status-icon tracking-details-flight-info-status-icon__grey';
        }
    };

    getCSSForFlightStatusItem = (input) => {
        if (input === undefined || input === null)
            return 'tracking-details-flight-info-list-item tracking-details-flight-info-list-item__grey';

        if (input.length > 0) {
            return 'tracking-details-flight-info-list-item tracking-details-flight-info-list-item__blue';
        } else {
            return 'tracking-details-flight-info-list-item tracking-details-flight-info-list-item__grey';
        }
    };

    getCSSForDeliveredTo = (deliveredTo) => {
        if (deliveredTo === undefined || deliveredTo === null)
            return 'tracking-details-flight-info-Signed-By-hide';
    };

    getTravelTimeLabel = (travelTime) => {
        if (travelTime === undefined || travelTime === null)
            return;

        if (travelTime.length > 0)
            return 'Travel time';
    };

    getTransitTime = (transitTime) => {
        if (transitTime === undefined || transitTime === null)
            return;

        if (transitTime.length > 0) {
            let transitTimeToReturn = '';
            let index = transitTime.indexOf(':');
            let hours = transitTime.substr(0, index);
            if (hours !== '00' || hours !== '0') {
                hours = hours.startsWith("0") ? hours.substr(1, hours.length) : hours;

                transitTimeToReturn += hours + ' hr ';
            }
            let minutesIndex = transitTime.substr(index + 1, transitTime.length).indexOf(':');
            let minutes = transitTime.substr(index + 1, minutesIndex);
            if (minutes !== '00' || minutes !== '0') {
                minutes = minutes.startsWith("0") ? minutes.substr(1, minutes.length) : minutes;
                transitTimeToReturn += minutes + ' min';
            }

            return transitTimeToReturn;
        }
    };

    handleDesktopNavClick = (event) => {
        this.setState({
            isOverlayShown: true,
            currentPopper: event.currentTarget.id,
        });
    };

    handlePopperClose = () => {
        this.setState({
            isOverlayShown: false,
            currentPopper: null,
        });
    };

    hasValue = (input) => {

        if (input === undefined || input === null){
            return false;
        }
        if (input.length > 0) {
            return true
        }
    }

    handleDesktopNavClickAway = () => {
        this.setState({
            isOverlayShown: false,
            currentPopper: null
        })
    };

    getCSSForFlightStatus = (input) => {

        if (input === undefined || input === null)
            return 'tracking-details-flight-info-status__grey text-uppercase';

        if (input.length > 0) {
            return 'tracking-details-flight-info-status__bold text-uppercase';
        } else {
            return 'tracking-details-flight-info-status__grey text-uppercase';
        }
    };

    getBookedSection = (bookingCompletionDate, awbCreateDate, tenderedDate) => {
        // Determine which date to use based on the condition that if bookingCompletionDate is after tenderedDate
        const useDate = bookingCompletionDate > tenderedDate ? awbCreateDate : bookingCompletionDate;
        if (useDate) {
            return <li className={this.getCSSForFlightStatusItem(useDate)}>
                <div className="tracking-details-flight-info-status-wrapper">
                    <div
                            className={this.getCSSForFlightStatusIcon(useDate)}>
                        <span className={this.getCSSForFlightStatus(useDate)}>Booked</span>
                    </div>
                    <div className="tracking-details-flight-info-right-wrapper">
                        {formatDateString(useDate, "MM/DD/YY")}
                        <p> {getWeekDayFromDateString(useDate)} </p>
                        <p className="tracking-details-flight-info-time-wrapper"><span
                                className="tracking-details-flight-info-time"> {getHours(useDate)} </span> {getAMorPM(useDate)}
                        </p>
                    </div>
                </div>
                <hr className="tracking-details-flight-info-line"/>
            </li>
        }
    };

    render() {

        return (
                <div ref={this.piecePopperNavigationAnchorElement}>
                    <ul className="unstyled-list tracking-details-flight-info-list">
                        {this.getBookedSection(this.props.bookingCompletionDate, this.props.awbCreateDate, this.props.tenderedDate)}
                        <li className={this.getCSSForFlightStatusItem(this.props.tenderedDate)}>
                            <div className="tracking-details-flight-info-status-wrapper">
                                <div
                                        className={this.getCSSForFlightStatusIcon(this.props.tenderedDate)}>
                                    <span className={this.getCSSForFlightStatus(this.props.tenderedDate)}>Tendered</span>
                                </div>
                                <div className="tracking-details-flight-info-right-wrapper">
                                    {formatDateString(this.props.tenderedDate, "MM/DD/YY")}
                                    <p> {getWeekDayFromDateString(this.props.tenderedDate)} </p>
                                    <p className="tracking-details-flight-info-time-wrapper"><span
                                            className="tracking-details-flight-info-time"> {getHours(this.props.tenderedDate)} </span> {getAMorPM(this.props.tenderedDate)}</p>
                                </div>
                            </div>
                            <hr className="tracking-details-flight-info-line"/>
                        </li>
                        <li className={this.getCSSForFlightStatusItem(this.props.manifestedDate)}>
                            <div className="tracking-details-flight-info-status-wrapper">
                                <div
                                        className={this.getCSSForFlightStatusIcon(this.props.manifestedDate)}>
                                    <span className={this.getCSSForFlightStatus(this.props.manifestedDate)}>Manifested</span>
                                </div>
                                <div className="tracking-details-flight-info-right-wrapper">
                                    {formatDateString(this.props.manifestedDate, "MM/DD/YY")}
                                    <p> {getWeekDayFromDateString(this.props.manifestedDate)} </p>
                                    <p className="tracking-details-flight-info-time-wrapper"><span
                                            className="tracking-details-flight-info-time"> {getHours(this.props.manifestedDate)} </span> {getAMorPM(this.props.manifestedDate)}</p>
                                </div>
                            </div>
                            <hr className="tracking-details-flight-info-line"/>
                        </li>
                        <li className={this.getCSSForFlightStatusItem(this.props.flightDetailScans)}>
                            <div className="tracking-details-flight-info-status-wrapper">
                                <div className={this.getCSSForFlightStatusIcon(this.props.flightDetailScans)}>
                                    <span className={this.getCSSForFlightStatus(this.props.flightDetailScans)}>En Route</span>
                                    { this.hasValue(this.props.flightDetailScans) ? (   <span className="text-lowercase"> <a onClick={this.handleDesktopNavClick} id="details">details</a> </span> )
                                            : null }
                                    <Popover
                                            className="piece-toolbar-popper"
                                            open={this.state.currentPopper === "details"}
                                            anchorEl={this.piecePopperNavigationAnchorElement.current}
                                            onClose={this.handlePopperClose}
                                            anchorPosition={'left'}
                                    >
                                        <ClickAwayListener onClickAway={this.handleDesktopNavClickAway}>
                                            <Fade timeout={300} in={this.state.currentPopper === "details"} id="menu-list">
                                                <div className="piece-popper piece-popper--ship">
                                                    <div className="piece-popper__nav">
                                                        <div className="piece-popper__title-container">
                                                            <div className="piece-popper__table whiteTable">
                                                                <div className="divTableBody">
                                                                    <div className="divTableRow">
                                                                        <div className="divTableCell">
                                                                            <div className="piece-popper__title" style={{textAlign: "right"}}><img className="piece-popper__ship-image" src="./assets/icons/shipping.svg" alt="Ship" /></div>
                                                                        </div>
                                                                        <div className="divTableCell" style={{verticalAlign: "top"}}>
                                                                            <div className="piece-popper__title" style={{margin: "0"}}>Shipment Details</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="piece-popper__marketing-container">
                                                            <TrackingDetailsPieceInfo
                                                                    awbPrefix={this.props.awbPrefix}
                                                                    airWaybillNumber={this.props.airWaybillNumber}
                                                                    isoCreateDate={this.props.isoCreateDate}
                                                                    legs={this.props.legs}
                                                                    numLots={this.props.numLots}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="piece-popper__marketing-container">
                                                    </div>
                                                    <button className="piece-popper__close" onClick={this.handlePopperClose}>
                                                        <img src="./assets/icons/close.svg" alt=""/>
                                                    </button>
                                                </div>
                                            </Fade>
                                        </ClickAwayListener>
                                    </Popover>
                                </div>
                                <div className="tracking-details-flight-info-right-wrapper">
                                    <span className="text-uppercase"> {this.getTravelTimeLabel(this.props.manifestedDate ? this.props.travelTime : null)} </span>
                                    <p className="tracking-details-flight-info-time-wrapper"><span
                                            className="tracking-details-flight-info-time">{this.getTransitTime(this.props.manifestedDate ? this.props.travelTime : null)} </span>
                                    </p>
                                </div>
                            </div>
                            <hr className="tracking-details-flight-info-line"/>
                        </li>
                        <li className={this.getCSSForFlightStatusItem(this.props.receivedDate)}>
                            <div className="tracking-details-flight-info-status-wrapper">
                                <div className={this.getCSSForFlightStatusIcon(this.props.receivedDate)}>
                                    <span className={this.getCSSForFlightStatus(this.props.receivedDate)}>On Hand</span>
                                </div>
                                <div className="tracking-details-flight-info-right-wrapper">
                                    {formatDateString(this.props.receivedDate, "MM/DD/YY")}
                                    <p> {getWeekDayFromDateString(this.props.receivedDate)} </p>
                                    <p className="tracking-details-flight-info-time-wrapper"><span
                                            className="tracking-details-flight-info-time">{getHours(this.props.receivedDate)} </span> {getAMorPM(this.props.receivedDate)}</p>
                                </div>
                            </div>
                            <hr className="tracking-details-flight-info-line"/>
                        </li>

                        <li className={this.getCSSForFlightStatusItem(this.props.deliveredDate)}>
                            <div className="tracking-details-flight-info-status-wrapper">
                                <div className={this.getCSSForFlightStatusIcon(this.props.deliveredDate)}>
                                    <span className={this.getCSSForFlightStatus(this.props.deliveredDate)}> Delivered </span>
                                </div>
                                <div className="tracking-details-flight-info-right-wrapper">
                                    {formatDateString(this.props.deliveredDate, "MM/DD/YY")}
                                    <p> {getWeekDayFromDateString(this.props.deliveredDate)} </p>
                                    <p className="tracking-details-flight-info-time-wrapper"><span
                                            className="tracking-details-flight-info-time">{getHours(this.props.deliveredDate)} </span> {getAMorPM(this.props.deliveredDate)}</p>
                                    <p className={this.getCSSForDeliveredTo(this.props.deliveredTo)}>
                                        SIGNED BY
                                    </p>
                                    <p className={this.getCSSForDeliveredTo(this.props.deliveredTo)}>
                                        {this.props.deliveredTo}
                                    </p>
                                </div>
                            </div>
                            <hr className="tracking-details-flight-info-line"/>
                        </li>

                    </ul>
                </div>
        )
    }
}

export default TrackingDetailsFlightInfo;



// WEBPACK FOOTER //
// ./src/components/TrackingDetailsFlightInfo/TrackingDetailsFlightInfo.js